<template>
    <div class="timeseries_wrapper chart_wrapper" id="ChartWrapper">
        <div class="loader lds-ellipsis" :class="(loaderDisplayed) ? 'displayed': ''"><div></div><div></div><div></div><div></div></div>
        <div class="highcharts_container" :id="chartID" ></div>
    </div>
</template>

<script>
    import * as UTILS from '~/commons/utils/index.js'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import {_} from 'underscore'
    var numberFormat = require('underscore.string/numberFormat')

    export default {
        props: {
            chartID: {
                type: String,
                default: function () {
                    return 'Timeseries'
                }
            },
            timeSeriesData: {
                type: Array,
                default: function () {
                    return []
                }
            },
            timeSeriesCategories: {
                type: Array, 
                default: function () {
                    return []
                }
            },
            indicatorUnit: {
                type: String, 
                default: function (){
                    return ""
                }
            },
            indicatorLabel: {
                type: String,
                default: function (){
                    return ""
                }
            },
            minY: {
                type: Number,
                default: function (){
                    return null
                }
            }
        },
        data: function () {
            return {
                timeSeriesHigcharts: '',
                orderedSeries: [],
                loaderDisplayed: true
            }
        },
        
        mounted () {
            var self = this;
            if(this.timeSeriesData.length > 0) this.renderTimeSeries();
        },
        methods: {

            renderTimeSeries: function () {
                var self = this;

                this.loaderDisplayed = true;

                var enabledLegend = true;
                if(this.timeSeriesData.length <= 1){
                    enabledLegend = false;
                }


                this.timeSeriesHigcharts = new Highcharts.chart({
                    chart:{
                        renderTo: self.chartID,
                        animation: false,
                        backgroundColor: "transparent",
                        type: "spline"
                    },
                    title: {
                        text: "",
                    },
                    xAxis: {
                        type: 'category',
                        gridLineDashStyle: "solid",
                        gridLineColor: "#BAC6Df",
                        gridLineWidth: 0,
                        lineWidth: 1,
                        lineColor: "#29264C",
                        categories: this.timeSeriesCategories,
                        showLastLabel: true,
                        endOnTick: true,
                        labels: {
                            formatter: function (){
                                if(this.isLast) return self.timeSeriesCategories[self.timeSeriesCategories.length - 1];
                                return this.value;
                            }
                        }
                    },
                    yAxis: {
                        gridLineDashStyle: "LongDash",
                        gridLineColor: "#BAC6Df",
                        gridLineWidth: 1,
                        lineWidth: 0,
                        min: self.minY,
                        title: {
                            enabled: false
                        },
                        labels: {
                            formatter: function (){
                                return this.value + " " + self.indicatorUnit
                            }
                        }
                    },
                    plotOptions:{
                        series:{
                            animation: false,
                            marker:{
                                symbol: "circle",
                                enabled: false
                            }
                        }
                    },
                    tooltip:{
                        useHTML: true,
                        formatter: function (){
                            var htmlTooltip = "<div class='tooltip_wrapper'>";
                            htmlTooltip += "<div class='tooltip_title'>"+this.x+"</div>";

                            var indicatorLabel = self.indicatorLabel;
                            if(indicatorLabel == "") indicatorLabel = this.series.name

                            var nbDecimals = 0;
                            if(self.indicatorUnit == "%") nbDecimals = 1;

                            htmlTooltip += "<div class='tooltip_value'><div class='value_label'>"+indicatorLabel+"</div><div class='value_figure'><div class='figure_bar' style='background-color:"+this.color+"'></div>" + numberFormat(this.y, nbDecimals, '', ',') + "" +self.indicatorUnit+"</div></div>";
                            htmlTooltip += "</div>";
                            return htmlTooltip;
                        }
                    },
                    legend: {
                        align: "left",
                        verticalAlign: "top",
                        enabled: enabledLegend,
                        itemStyle: {
                            color: "#29264C"
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    series: self.timeSeriesData
                });

                this.loaderDisplayed = false;
            },
        },
        watch: {
            timeSeriesData: function () {
                if(this.timeSeriesData[0] !== undefined) {
                    this.renderTimeSeries();
                } else {

                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    .timeseries_wrapper{
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;
        margin-top: 20px;

        .highcharts_container{
            min-height: 400px;
        }
    }
</style>



// WEBPACK FOOTER //
// components/highchartsTimeSeries.vue